import apiService from "./apiService";

const userService = {
   
    async getOperatorStats(){
        try {
            return (await apiService.get(`emergency/get-operator-dbinfo/`, {}, true)).data;
        }
        catch {
            return {success: false, message: "An error occured while processing the request"};
        }
    },
  async  forceReleaseResponder(id){
    try{
        return (await apiService.put(`emergency/${id}/force-release`,{},true)).data;
    }
    catch{
        return {success: false, message: "Failed to release responder: An error occured while processing the request."}
    }
  }
};

export default userService;